<template>
    <div class="container">
        <img
            :src="'/svg/lemonTree/' + img"
            alt="lemonTree"
            class="lemon shadow-sm"
        />
    </div>
</template>

<script>
import {getSizeAvatar} from "@/helper";

export default {
    data() {
        return {
            img: "",
        };
    },
    async mounted() {
        try {
            this.img = (await getSizeAvatar()).img;
        } catch (e) {
            console.error("**************", e);
        }
    },
};
</script>

<style lang="scss" scoped>
.container {
    height: 16vh;
    width: 100%;
}

.lemon {
    background: white;
    border-radius: 100%;
    height: 100%;
    margin: 0 auto;
}

.darkLeaf {
    left: -77px;
    position: fixed;
    top: -150px;
    transform: rotate(-12deg);
    width: 334px;
    z-index: 20;
}
</style>
